import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addReportRes;
export const addReportTodo = createAsyncThunk('addReport', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'report/add_report_data',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "start_date": data.start_date ? data.start_date : '',
                "end_date": data.end_date ? data.end_date : '',
                "print_reason": data.reason ? data.reason : '',
                "print_by": user_id.vemp_code,
                "report_type": data.type ? data.type : '',
                "dept_id": data.department_wise ? data.department_wise : '',
                "fk_user_id": data.user_wise ? data.user_wise : '',
                "session_id": data.session_wise ? data.session_wise : '',
                "learning_module_id": data.learning_module_wise ? data.learning_module_wise : '',
                "learning_track_id": data.learning_track_wise ? data.learning_track_wise : '',
                'group_id': data.group_wise ? data.group_wise : '',
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addReportRes = res.data
    } catch (error) {
        return addReportRes = error.response.data
    }
})